import { withNamespaces } from "react-i18next";
import { useMemo } from "react";
import { Col, Container, Row } from "reactstrap";
import { useLocation } from "react-router-dom";
// styles
import "./style.scss";
// components
import Tabs from "./tabs";

// Contents
import DataProtectionSoftwareList from "src/modules/data-protection/pages/admin/other-assets/list";
import PageBody from "../../../components/page-body";
import PageContent from "../../../components/page-content";
import Navigator from "src/components/Navigator";
import OtherAssetsService from "../../../apis/OtherAssetsService";
import { useQuery } from "@tanstack/react-query";

const OtherAssets = () => {
    const location = useLocation();

    const navigatorOptions = useMemo(() => {
        return {
            enable: true,
            pageTitle: "Other Assets",
                            breadCrumbs: [
                {
                    title: "SIP",
                    link: "/admin/data-protection/dashboard",
                },
                {
                    title: "Other Assets",
                    link: "#",
                }
            ]
        }
    }, []);

    const {
        data: softwaresCount
    } = useQuery({
        queryKey: ["data-protection-other-assets-count"],
        queryFn: async () => {
            const service = OtherAssetsService.getInstance();
            return await service.getCount();
        }
    });

    const currentTab = (new URLSearchParams(location.search)).get('tab');

    return (
        <PageContent classNames="data-protection-software-details-page software-details-page">
            <Container fluid>
                <Row>
                    {navigatorOptions.enable && (
                        <Col lg="12" className="mb-4">
                            <Navigator
                                pageTitle={navigatorOptions.pageTitle}
                                breadCrumbs={navigatorOptions.breadCrumbs}
                            />
                        </Col>
                    )}
                </Row>

                <PageBody classNames="p-0">
                    <div className="details-content-wrapper">
                        <Tabs 
                            totalCount={softwaresCount?.data?.all || 0} 
                            deletedCount={softwaresCount?.data?.deleted || 0} 
                        />

                        {currentTab && (
                            <DataProtectionSoftwareList 
                                tab={currentTab}
                            />
                        )}
                    </div>
                </PageBody>
            </Container>
        </PageContent>
    );
};

export default withNamespaces()(
    OtherAssets
);
